module.exports = __webpack_public_path__ + "static/media/herobg_16by9.8dc90f1f.jpg";